import React from 'react';
import {
  Button, Dialog, DialogContent, DialogTitle, IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import DialogActions from '@mui/material/DialogActions';
import { VARIANTS } from 'shared/constants';
import { useLoading } from 'shared/hooks';
import StickyHeadTable from './StickyHeadTable';

/**
 * @param {Object} props
 * @param {React.ReactNode} [props.children=null]
 * @param {Array<Object>} props.columns
 * @param {string} props.noRowsText
 * @param {string} props.rowId
 * @param {Array<*>} [props.rows=[]]
 * @param {Function} props.setShow
 * @param {boolean} props.show
 * @param {string} props.title
 */
export default function ModalTable(props) {
  const {
    children = null,
    columns,
    noRowsText,
    rowId,
    rows = [],
    setShow,
    show,
    title,
  } = props;
  const { isLoading } = useLoading();

  return (
    <Dialog onClose={() => setShow(false)} open={show}>
      <DialogTitle>
        {title}
      </DialogTitle>
      <IconButton
        onClick={() => setShow(false)}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,

        }}
      >
        <Close />
      </IconButton>
      <DialogContent>
        {children}
        <StickyHeadTable
          columns={columns}
          isLoading={isLoading}
          noRowsText={noRowsText}
          rowId={rowId}
          rows={rows}
          striped
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant={VARIANTS.primary}
          onClick={() => setShow(false)}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
